module.exports = __webpack_public_path__ + "media/img/pages/profile/vaudoise ger 2-b7cbdaf0ebef851f7556e94124e7685a.jpg";